import { productQuantityBreakPricingStyles as styles } from "@iewccouk/Overrides/Components/ProductQuantityBreakPricing";
import { colorStrings } from "@iewccouk/Utilities/variables";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

styles.tableHead = {
    ...styles.tableHead,
    css: css`
        border: 1px solid ${getColor(colorStrings.textMain)};
        &&& {
            th {
                border: 0;
                text-align: left;
            }
        }
    `,
};

styles.tableBody = {
    ...styles.tableBody,
    css: css`
        &&& {
            border: 1px solid ${getColor(colorStrings.commonGlobalGray03)};
            border-top: 0;
            tr {
                border: 0;
                &:nth-child(odd) {
                    background-color: ${getColor(colorStrings.commonGlobalGray05)};
                }

                &:nth-child(even) {
                    background-color: ${getColor(colorStrings.commonGlobalWhite)};
                }

                td {
                    border: 0;
                    text-align: left;
                }
            }
        }
    `,
};

styles.viewLink = {
    ...styles.viewLink,
    css: css`
        width: auto;
        pointer-events: none;
    `,
    typographyProps: {
        ...styles.viewLink?.typographyProps,
        css: css`
            pointer-events: all;
        `,
    },
};
